import { getBnySatBaseUrl, getBnySatGraphBaseUrl } from '../../services/apiService';
import { apiCall, createApiThunk, graphqlCall } from '../../utils/api';
import { print } from 'graphql';
import {
  getAllBasketsQuery,
  getAllLookupValuesQuery,
  getBasketDetailsQuery,
  getBasketsByClientQuery,
  getNewBasketQuery,
  processSecuritiesQuery,
  searchSecurityMasterQuery,
} from './OrderEntryQueries';
import {
  normalizeKeyword,
  SecurityIdentifierField,
  SecurityInput,
  toGraphqlKeywordLiteral,
} from '../../utils/securityMasterCache';

export const getAllLookupValuesThunk = createApiThunk('GET_ALL_LOOKUP_VALUES', graphqlCall);
export const getAllBasketsThunk = createApiThunk('GET_ALL_BASKETS', graphqlCall);
export const getBasketDetailsThunk = createApiThunk('GET_BASKET_DETAILS', graphqlCall);
export const getNewBasketThunk = createApiThunk('GET_NEW_BASKET', graphqlCall);
export const getBasketsByClientThunk = createApiThunk('GET_BASKETS_BY_CLIENT', graphqlCall);
export const createOnClientApproval = createApiThunk('CREATE_ON_CLIENT_APPROVAL', apiCall);
export const createOnClientApprovalResend = createApiThunk(
  'CREATE_ON_CLIENT_APPROVAL_RESEND',
  apiCall,
);
export const onBasketUpdateThunk = createApiThunk('ON_BASKET_UPDATE_THUNK', apiCall);
export const onOrderExecuteThunk = createApiThunk('ON_ORDER_EXECUTE', apiCall);
export const searchSecurityMasterThunk = createApiThunk('SEARCH_SECURITY_MASTER', graphqlCall);
export const processSecuritiesThunk = createApiThunk('PROCESS_SECURITIES', graphqlCall);

export const onClientApproval = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getBnySatBaseUrl()}/v1/bny/trades`;
  return dispatch(createOnClientApproval({ url, method: 'POST', data }));
};

export const getAllLookupValues = () => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getAllLookupValuesQuery('Order Entry'));
  dispatch(getAllLookupValuesThunk({ url, query }));
};

export const getAllBaskets = () => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getAllBasketsQuery());
  dispatch(getAllBasketsThunk({ url, query }));
};

export const getBasketsByClient = (clientId: string) => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getBasketsByClientQuery(clientId));
  dispatch(getBasketsByClientThunk({ url, query }));
};

export const getBasketDetails =
  (basketId: string, version: number, currency: string, isNotNew: boolean) =>
  (dispatch: AppDispatch) => {
    const url = getBnySatGraphBaseUrl();
    const query = print(getBasketDetailsQuery(basketId, version, currency));
    const newQuery = print(getNewBasketQuery(basketId, currency));
    if (isNotNew) {
      return dispatch(getBasketDetailsThunk({ url, query, params: { currency } }));
    }
    return dispatch(getNewBasketThunk({ url, query: newQuery, params: { currency } }));
  };

export const onClientApprovalResend =
  (orderId: any, version: number, basketRouting: string) => (dispatch: AppDispatch) => {
    const url = `${getBnySatBaseUrl()}/v1/bny/trades/${orderId}/${version}/resend?basketRouting=${basketRouting}`;
    return dispatch(createOnClientApprovalResend({ url, method: 'PUT', data: null }));
  };

export const onBasketUpdate =
  (basketId: any, version: number, basketData: any) => (dispatch: AppDispatch) => {
    const url = `${getBnySatBaseUrl()}/v1/bny/basket/${basketId}/${version}/items`;
    return dispatch(onBasketUpdateThunk({ url, method: 'POST', data: basketData }));
  };

export const onOrderExecute =
  (orderId: string, version: number, timestamp: string) => (dispatch: AppDispatch) => {
    const url = `${getBnySatBaseUrl()}/v1/bny/trades/${orderId}/${version}/execute?timestamp=${timestamp}`;
    return dispatch(onOrderExecuteThunk({ url, method: 'PUT', data: null }));
  };

export const searchSecurityMaster =
  (keyword: string, field: SecurityIdentifierField) => (dispatch: AppDispatch) => {
    const searchKeyword = normalizeKeyword(keyword);
    const url = getBnySatGraphBaseUrl();
    const query = print(searchSecurityMasterQuery(toGraphqlKeywordLiteral(searchKeyword), field));
    return dispatch(
      searchSecurityMasterThunk({ url, query, params: { keyword: searchKeyword, column: field } }),
    );
  };

export const processSecurities = (securities: SecurityInput[]) => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(processSecuritiesQuery);
  return dispatch(processSecuritiesThunk({ url, query, variables: { securities } }));
};
